import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createGlobalStyle } from 'styled-components';

export const GlobalSkeletonStyles = createGlobalStyle`
  .skeleton_full_width_container {
    width: 100%;
    display: inline-block;
  }
`;

const WithSkeleton = ({ shouldRender, enableAnimation, children, fullWidthContainer, ...rest }) => {
  return shouldRender ? (
    <>{children}</>
  ) : (
    <Skeleton enableAnimation={enableAnimation} containerClassName={fullWidthContainer ? 'skeleton_full_width_container' : ''} {...rest} />
  );
};

export default WithSkeleton;
